import { Badge, Button, Card, ErrorText } from '@/components/ui'
import { formatDayMonth, formatNumber } from '@/lib/format'

import { useSyncQuests, useWeeklyQuests } from './quests'

export function WeeklyQuestsCard({ className }: { className?: string }) {
  const week = useWeeklyQuests()
  const refresh = useSyncQuests('character')
  const data = Array.isArray(week.data?.quests) ? week.data : undefined
  return (
    <Card title="Задания недели" className={className}
      subtitle={data ? `С ${formatDayMonth(data.week_start)} до понедельника · ${data.timezone}` : 'Два или три задания по твоим данным.'}
      actions={<Button variant="ghost" loading={refresh.isPending} onClick={() => refresh.mutate()}>Обновить</Button>}
    >
      {data?.quests.length ? (
        <>
          <ul className="divide-y divide-border" aria-label="Задания недели">
            {data.quests.map((quest) => (
              <li key={quest.id} className="py-3 first:pt-0 last:pb-0">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h3 className="text-sm font-semibold">{quest.title}</h3>
                  <Badge tone={quest.completed_at ? 'accent' : undefined}>
                    {quest.completed_at ? 'Получено' : 'Бонус'} +{quest.reward_xp} XP
                  </Badge>
                </div>
                <p className="mt-1 text-sm text-muted">{quest.description}</p>
                <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-surface-2" role="progressbar"
                  aria-label={quest.title} aria-valuemin={0} aria-valuemax={quest.target} aria-valuenow={quest.progress}>
                  <div className="h-full rounded-full bg-accent" style={{ width: `${Math.min(100, quest.progress / quest.target * 100)}%` }} />
                </div>
                <p className="mt-1 text-xs text-muted">
                  {quest.completed_at ? 'Выполнено · ' : ''}{formatNumber(quest.progress)} / {quest.target} {quest.unit}
                </p>
              </li>
            ))}
          </ul>
          <p className="mt-4 text-xs text-muted">За неделю получено {data.earned_xp} XP. Бонусы начисляются автоматически и сохраняются.</p>
        </>
      ) : (
        <p className="text-sm text-muted">{week.isPending || refresh.isPending ? 'Подбираем задания…' : 'Задания появятся при подключении к серверу.'}</p>
      )}
      {week.error || refresh.error ? <ErrorText error={refresh.error ?? week.error}>Не удалось обновить задания. Попробуй ещё раз.</ErrorText> : null}
    </Card>
  )
}
